const tokensNL = {
    "view": {
        "title": "Tokengeschiedenis",
        "table": {
            "column": {
                "quantity": "Aantal",
                "description": "Beschrijving",
                "type": "Type",
                "balance": "Saldo",
                "date": "Datum",
                "receipt": "Bon"
            },
            "placeholder": {
                "search": "Zoeken..."
            },
            "button": {
                "view": "Bekijken",
                "export_csv": "CSV exporteren",
                "order_tokens": "Tokens bestellen"
            },
            "label": {
                "not_available": "Niet beschikbaar",
                "credit": "Credit",
                "debit": "Debet"
            }
        }
    },
    "order": {
        "title": "Tokens bestellen",
        "form": {
            "label": {
                "quantity": "Aantal"
            },
            "placeholder": {
                "quantity": "Selecteer aantal"
            },
            "help": {
                "quantity": "Aantal tokens dat je wilt bestellen."
            },
            "validation": {
                "quantityRequired": "Aantal is verplicht"
            },
            "button": {
                "placeOrder": "Bestelling plaatsen"
            },
            "option": {
                "tokensAmount": "{{count}} tokens"
            }
        },
        "modal": {
            "title": "Ga verder naar afrekenen",
            "orderedPrefix": "Je hebt besteld",
            "description": "Als je de bestelling wilt bevestigen, ga dan verder naar afrekenen. Anders kun je de bestelling annuleren.",
            "button": {
                "cancel": "Annuleren",
                "checkout": "Afrekenen"
            }
        },
        "message": {
            "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!"
        }
    },
    "transaction": {
        "success": {
            "title": "Transactie geslaagd :)",
            "description": "Je hebt de tokens succesvol gekocht. Ze worden binnenkort aan je account toegevoegd!"
        },
        "cancel": {
            "title": "Transactie geannuleerd :(",
            "description": "De transactie is geannuleerd... Probeer het later opnieuw!"
        },
        "button": {
            "returnToDashboard": "Terug naar dashboard"
        }
    }
};

export default tokensNL;
